import { render, staticRenderFns } from "./OrderTimeChart.vue?vue&type=template&id=b338a622&scoped=true&"
import script from "./OrderTimeChart.vue?vue&type=script&lang=js&"
export * from "./OrderTimeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b338a622",
  null
  
)

export default component.exports